import { render, staticRenderFns } from "./p08.vue?vue&type=template&id=4f290260&scoped=true&"
import script from "./p08.vue?vue&type=script&lang=js&"
export * from "./p08.vue?vue&type=script&lang=js&"
import style0 from "./p08.vue?vue&type=style&index=0&id=4f290260&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f290260",
  null
  
)

export default component.exports